import { defineSection } from "~/content/define"

export const contactCtaSection = defineSection({
  id: "contact-cta",
  heading: "Let’s talk about how we can help.",
  body: "Tell us where you are and where you want to go.",
})
